/*
 * OB TIE DYE | GUIDE NAVIGATION LAYER (Oct 7 2026)
 * ------------------------------------------------------------
 * Small add-on that ties the SoCal guide and the destination guides together.
 * ob-guide-v3.js and ob-guide-landing.js are untouched; this only adds on top.
 *
 * 1. "You are here" bar under the hero (Events > SoCal > Orange County, or Events > Destinations > Las Vegas)
 *    with an Events / Happy hours + weekly switch on the right.
 * 2. The hero place picker gets two groups, SoCal and Destinations. Picking a place in the other
 *    group opens that guide; picking an area in the same group filters in place like before.
 * 3. Every quick filter tap (When pills, hero area picker, chip row) scrolls to the results header
 *    and shows a short "Showing 28 events this weekend in Orange County" note.
 * 4. Next Weekend filters in place instead of reloading the page.
 * 5. On pages with the When pills, the duplicate Today / This Weekend chips in the chip row are hidden (CSS).
 *
 * To undo everything: remove the two ob-guide-nav lines near the end of layout/theme.liquid.
 */
(function(){
  'use strict';
  var ROOT=document.getElementById('obg');
  if(!ROOT||ROOT.__obnav)return;ROOT.__obnav=true;

  var PLACES={
    socal:{name:'SoCal',group:'SoCal',home:'events',weekly:'events-happy-hours',all:'All of SoCal'},
    /* Oct 20 2026: the five Southern California destinations (each shows only its own events, with its areas as filters) */
    sd:{name:'San Diego',group:'SoCal',socal:true,home:'events-san-diego',weekly:'events-happy-hours',all:'All of San Diego'},
    la:{name:'Los Angeles',group:'SoCal',socal:true,home:'events-los-angeles',weekly:'events-happy-hours',all:'All of Los Angeles'},
    oc:{name:'Orange County',group:'SoCal',socal:true,home:'events-orange-county',weekly:'events-happy-hours',all:'All of Orange County'},
    ps:{name:'Palm Springs + Joshua Tree',group:'SoCal',socal:true,home:'events-palm-springs-joshua-tree',weekly:'events-happy-hours',all:'All of Palm Springs + Joshua Tree'},
    iem:{name:'Inland Empire',group:'SoCal',socal:true,home:'events-inland-empire',weekly:'events-happy-hours',all:'All of Inland Empire'},
    clt:{name:'Charlotte',group:'Destinations',home:'events-charlotte',weekly:'events-charlotte-happy-hours',all:'All of Charlotte'},
    den:{name:'Denver',group:'Destinations',home:'events-denver',weekly:'events-denver-happy-hours',all:'All of Denver'},
    hnl:{name:'Honolulu',group:'Destinations',home:'events-honolulu',weekly:'events-honolulu-happy-hours',all:'All of Honolulu'},
    lv:{name:'Las Vegas',group:'Destinations',home:'events-las-vegas',weekly:'events-las-vegas-happy-hours',all:'All of Las Vegas'},
    msp:{name:'Minneapolis / St. Paul',group:'Destinations',home:'events-minneapolis-st-paul',weekly:'events-minneapolis-st-paul-happy-hours',all:'All of the Twin Cities'},
    pdx:{name:'Portland',group:'Destinations',home:'events-portland',weekly:'events-portland-happy-hours',all:'All of Portland'},
    slc:{name:'Salt Lake City',group:'Destinations',home:'events-salt-lake-city',weekly:'events-salt-lake-city-happy-hours',all:'All of Salt Lake'},
    dc:{name:'Washington, DC',group:'Destinations',home:'events-washington-dc',weekly:'events-washington-dc-happy-hours',all:'All of DC'},
    /* Oct 22 2026: Phoenix (Arizona tab) and Tokyo (Japan tab, with Hakone, Kyoto + Nara, Osaka and side trips as areas) */
    phx:{name:'Phoenix',group:'Destinations',home:'events-phoenix',weekly:'events-phoenix-happy-hours',all:'All of Phoenix'},
    tem:{name:'Tempe',group:'Destinations',home:'events-tempe',weekly:'events-tempe-happy-hours',all:'All of Tempe'},
    tyo:{name:'Tokyo',group:'Destinations',home:'events-tokyo',weekly:'events-tokyo-happy-hours',all:'All of Tokyo + trips'}
  };
  /* page handle -> place, extra crumb, mode */
  var PAGES={
    'events':{p:'socal'},
    'events-san-diego':{p:'sd'},
    'events-orange-county':{p:'oc'},
    'events-los-angeles':{p:'la'},
    'events-palm-springs-joshua-tree':{p:'ps'},
    'events-inland-empire':{p:'iem'},
    'events-inland-desert':{p:'socal',c:'Inland + Desert'},
    'events-live-music':{p:'socal',c:'Live music'},
    'events-markets':{p:'socal',c:'Markets'},
    'events-food-drink':{p:'socal',c:'Food + drink'},
    'events-outdoors':{p:'socal',c:'Outdoors'},
    'events-festivals':{p:'socal',c:'Festivals + fairs'},
    'events-comedy':{p:'socal',c:'Comedy'},
    'events-dog-friendly':{p:'socal',c:'Dog friendly'},
    'events-free':{p:'socal',c:'Free'},
    'events-happy-hours':{p:'socal',m:'weekly'},
    'events-las-vegas':{p:'lv'},
    'events-las-vegas-happy-hours':{p:'lv',m:'weekly'},
    'events-charlotte':{p:'clt'},
    'events-charlotte-happy-hours':{p:'clt',m:'weekly'},
    'events-minneapolis-st-paul':{p:'msp'},
    'events-minneapolis-st-paul-happy-hours':{p:'msp',m:'weekly'},
    'events-denver':{p:'den'},
    'events-denver-happy-hours':{p:'den',m:'weekly'},
    'events-honolulu':{p:'hnl'},
    'events-honolulu-happy-hours':{p:'hnl',m:'weekly'},
    'events-washington-dc':{p:'dc'},
    'events-washington-dc-happy-hours':{p:'dc',m:'weekly'},
    'events-salt-lake-city':{p:'slc'},
    'events-salt-lake-city-happy-hours':{p:'slc',m:'weekly'},
    'events-portland':{p:'pdx'},
    'events-portland-happy-hours':{p:'pdx',m:'weekly'},
    'events-phoenix':{p:'phx'},
    'events-phoenix-happy-hours':{p:'phx',m:'weekly'},
    'events-tempe':{p:'tem'},
    'events-tempe-happy-hours':{p:'tem',m:'weekly'},
    'events-tokyo':{p:'tyo'},
    'events-tokyo-happy-hours':{p:'tyo',m:'weekly'}
  };
  /* other guide pages people can jump to from the place picker */
  var JUMPS={
    socal:[['events','All of SoCal'],['events-san-diego','San Diego'],['events-los-angeles','Los Angeles'],['events-orange-county','Orange County'],['events-palm-springs-joshua-tree','Palm Springs + Joshua Tree'],['events-inland-empire','Inland Empire']],
    lv:[['events-las-vegas','Las Vegas'],['events-charlotte','Charlotte'],['events-minneapolis-st-paul','Minneapolis / St. Paul'],['events-denver','Denver'],['events-honolulu','Honolulu'],['events-washington-dc','Washington, DC'],['events-salt-lake-city','Salt Lake City'],['events-portland','Portland'],['events-phoenix','Phoenix'],['events-tempe','Tempe'],['events-tokyo','Tokyo']]
  };

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function handle(){
    var v='';try{v=new URL(location.href).searchParams.get('view')||''}catch(_){}
    var h=location.pathname.replace(/\/+$/,'').split('/').pop();
    if(h==='events'&&v)return v;
    return h;
  }
  function url(h){return '/pages/'+h}
  var H=handle(),PAGE=PAGES[H]||{p:'socal'},PLACE=PLACES[PAGE.p],WEEKLY=PAGE.m==='weekly';
  /* Oct 16 2026: any destination (Las Vegas, Charlotte) behaves the way Las Vegas did */
  var DEST=PLACE.group==='Destinations'||!!PLACE.socal;

  /* ---------- 1. you-are-here bar ---------- */
  function buildBar(){
    if(ROOT.querySelector('.obn-bar'))return;
    var crumbs=['<a href="'+url('events')+'">Events</a>'];
    if(PLACE.socal){
      crumbs.push('<a href="'+url('events')+'">SoCal</a>');
      crumbs.push(WEEKLY?'<a href="'+url(PLACE.home)+'">'+esc(PLACE.name)+'</a>':'<span aria-current="page">'+esc(PLACE.name)+'</span>');
    }else if(DEST){
      crumbs.push('<span>Destinations</span>');
      crumbs.push(WEEKLY?'<a href="'+url(PLACE.home)+'">'+esc(PLACE.name)+'</a>':'<span aria-current="page">'+esc(PLACE.name)+'</span>');
    }else{
      crumbs.push(PAGE.c||WEEKLY?'<a href="'+url('events')+'">SoCal</a>':'<span aria-current="page">SoCal</span>');
      if(PAGE.c)crumbs.push('<span aria-current="page">'+esc(PAGE.c)+'</span>');
    }
    if(WEEKLY)crumbs.push('<span aria-current="page">Happy hours + weekly</span>');
    var sep='<svg class="obn-sep" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
    var back=DEST&&!PLACE.socal?'<a class="obn-back" href="'+url('events')+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>SoCal guide</a>':'';
    var mode='<div class="obn-mode" role="group" aria-label="Show">'+
      '<a href="'+url(PLACE.home)+'"'+(WEEKLY?'':' aria-current="page"')+'>Events</a>'+
      '<a href="'+url(PLACE.weekly)+'"'+(WEEKLY?' aria-current="page"':'')+'>Happy hours + weekly</a></div>';
    var bar=document.createElement('div');bar.className='obn-bar';
    bar.innerHTML='<nav class="obn-crumbs" aria-label="You are here"><svg class="obn-pin" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>'+crumbs.join(sep)+back+'</nav>'+mode;
    /* Oct 7 2026: OB Tie Dye Picks sit first under the hero, then this bar, then the When/Where rows */
    var disc=ROOT.querySelector('.obl-discover'),picks=disc&&disc.querySelector('.obl-picks'),hero=ROOT.querySelector('.obg-hero');
    if(disc){
      if(picks)disc.insertBefore(picks,disc.firstChild);
      disc.insertBefore(bar,picks?picks.nextSibling:disc.firstChild);
    }else if(hero&&hero.parentNode)hero.parentNode.insertBefore(bar,hero.nextSibling);
    else ROOT.insertBefore(bar,ROOT.firstChild);
    ROOT.classList.add('obn-on');
  }

  /* ---------- 2. grouped place picker ---------- */
  var GO='__go:';
  function groupSelect(){
    var sel=document.getElementById('obgHeroRegion');
    if(!sel||sel.__obnBusy)return;
    if(sel.querySelector('optgroup[data-obn]'))return;
    var own=Array.prototype.slice.call(sel.options).filter(function(o){return o.value.indexOf(GO)!==0});
    if(!own.length)return;
    sel.__obnBusy=true;
    var cur=sel.value;
    var mine=document.createElement('optgroup');mine.label=PLACE.socal?PLACE.name:(DEST?'Destinations · '+PLACE.name:'SoCal');mine.setAttribute('data-obn','mine');
    own.forEach(function(o){mine.appendChild(o)});
    if(DEST){
      var soc=document.createElement('optgroup');soc.label='Southern California';soc.setAttribute('data-obn','other');
      JUMPS.socal.forEach(function(j){if(j[0]===PLACE.home)return;var o=document.createElement('option');o.value=GO+j[0];o.textContent=j[1];soc.appendChild(o)});
      var odst=document.createElement('optgroup');odst.label='Other destinations';odst.setAttribute('data-obn','other');
      JUMPS.lv.forEach(function(j){if(j[0]===PLACE.home)return;var o=document.createElement('option');o.value=GO+j[0];o.textContent=j[1];odst.appendChild(o)});
      sel.appendChild(soc);sel.appendChild(mine);if(odst.children.length)sel.appendChild(odst);
    }else{
      var sdst=document.createElement('optgroup');sdst.label='SoCal destinations';sdst.setAttribute('data-obn','other');
      JUMPS.socal.forEach(function(j){if(j[0]==='events')return;var o=document.createElement('option');o.value=GO+j[0];o.textContent=j[1];sdst.appendChild(o)});
      var dst=document.createElement('optgroup');dst.label='Other destinations';dst.setAttribute('data-obn','other');
      JUMPS.lv.forEach(function(j){var o=document.createElement('option');o.value=GO+j[0];o.textContent=j[1];dst.appendChild(o)});
      sel.appendChild(mine);sel.appendChild(sdst);sel.appendChild(dst);
    }
    sel.value=cur;
    sel.__obnBusy=false;
  }
  function watchSelect(){
    var sel=document.getElementById('obgHeroRegion');if(!sel)return;
    groupSelect();
    if(window.MutationObserver)new MutationObserver(function(){if(!sel.__obnBusy)groupSelect()}).observe(sel,{childList:true});
    /* runs before the guide's own change listeners, so a jump never reaches the guide as a region */
    document.addEventListener('change',function(e){
      if(e.target!==sel||sel.value.indexOf(GO)!==0)return;
      e.stopImmediatePropagation();
      var h=sel.value.slice(GO.length);
      ROOT.classList.add('obn-leaving');
      toast('Opening '+(h==='events'?'the SoCal guide':(sel.options[sel.selectedIndex]||{}).text||'guide')+'…');
      location.href=url(h);
    },true);
  }

  /* ---------- 3. scroll to results + confirm ---------- */
  function hdr(){var v=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--obl-hdr'));return isNaN(v)?0:v}
  function toResults(){
    var t=ROOT.querySelector('.obg-results-head');if(!t)return;
    var y=t.getBoundingClientRect().top+window.scrollY-hdr()-12;
    if(Math.abs(y-window.scrollY)<40)return;
    window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
  }
  function toast(msg){
    var t=ROOT.querySelector('.obg-toast');
    if(!t){t=document.createElement('div');t.className='obg-toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');ROOT.appendChild(t)}
    t.textContent=msg;t.classList.add('is-on');clearTimeout(toast._t);toast._t=setTimeout(function(){t.classList.remove('is-on')},2600);
  }
  var WHEN={today:'today',tonight:'tonight',weekend:'this weekend',week:'this week',month:'this month'};
  function summary(){
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    var c=(document.getElementById('obgCount')||{}).textContent||'';
    var n=(c.match(/[\d,]+/)||[''])[0];
    var line='Showing '+(n?n+' ':'')+(n==='1'?'event':'events');
    if(st){
      if(WHEN[st.when])line+=' '+WHEN[st.when];
      else if(st.when==='custom'&&lastNext&&st.from===lastNext[0]&&st.to===lastNext[1])line+=' next weekend';
      else if(st.when==='custom'&&st.from)line+=' for '+(st.from===st.to||!st.to?fmt(st.from):fmt(st.from)+' to '+fmt(st.to));
      if(st.region&&st.region!=='all')line+=' in '+st.region.split(' / ')[0];
      else line+=DEST?' across '+PLACE.name:' across SoCal';
    }
    return line;
  }
  function fmt(k){var a=String(k).split('-');if(a.length<3)return k;return['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][+a[1]-1]+' '+(+a[2])}
  var pending,lastNext=null;
  function confirmChange(){
    clearTimeout(pending);
    /* let ob-guide-landing.js do its own jump first, then land on the actual results */
    pending=setTimeout(function(){toResults();toast(summary())},380);
  }
  function fire(el){if(el)el.dispatchEvent(new Event('change',{bubbles:true}))}
  function nextWeekend(a){
    var u;try{u=new URL(a.href)}catch(_){return false}
    var f=u.searchParams.get('from'),t=u.searchParams.get('to');
    var r=ROOT.querySelector('input[name="obg-when"][value="custom"]'),fi=document.getElementById('obgFrom'),ti=document.getElementById('obgTo');
    if(!f||!t||!r||!fi||!ti)return false;
    r.checked=true;fire(r);
    fi.value=f;fire(fi);fi.dispatchEvent(new Event('input',{bubbles:true}));
    ti.value=t;fire(ti);ti.dispatchEvent(new Event('input',{bubbles:true}));
    var st=null;try{st=window.OB_GUIDE_V3.state()}catch(_){}
    if(st&&st.from!==f)return false;
    lastNext=[f,t];
    try{var cu=new URL(location.href);cu.searchParams.delete('when');cu.searchParams.set('from',f);cu.searchParams.set('to',t);history.replaceState(history.state,'',cu.toString())}catch(_){}
    return true;
  }
  function bindTaps(){
    document.addEventListener('click',function(e){
      var t=e.target;if(!t.closest)return;
      var w=t.closest('#obg [data-obl-when]');
      if(w){
        var k=w.getAttribute('data-obl-when');
        if(k==='pick')return;
        if(k==='nextweekend'){
          if(nextWeekend(w)){
            e.preventDefault();e.stopImmediatePropagation();
            Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-when]'),function(x){if(x.tagName==='BUTTON'||x===w)x.setAttribute('aria-pressed',x===w?'true':'false')});
            confirmChange();
          }
          return;
        }
        /* clear Next Weekend's pressed look when another pill is chosen */
        Array.prototype.forEach.call(ROOT.querySelectorAll('a[data-obl-when]'),function(x){x.setAttribute('aria-pressed','false')});
        confirmChange();return;
      }
      if(t.closest('#obgChips [data-chip]'))confirmChange();
    },true);
    document.addEventListener('change',function(e){
      if(e.target&&e.target.id==='obgHeroRegion'&&e.isTrusted&&e.target.value.indexOf(GO)!==0)confirmChange();
    });
  }

  /* ---------- 5. flag pages that have the When pills (CSS hides the duplicate chips) ---------- */
  function flagWhen(){if(ROOT.querySelector('[data-obl-when]'))ROOT.classList.add('obn-has-when')}

  /* Oct 7 2026: always-on modules (Residencies + long-running shows) sit below the full event list.
     They keep the discovery block's styling by moving inside their own copy of that wrapper. */
  function moveResidencies(){
    var disc=ROOT.querySelector('.obl-discover'),browser=ROOT.querySelector('.obg-browser');if(!disc||!browser)return;
    Array.prototype.forEach.call(disc.querySelectorAll('[data-obl-mod]'),function(sec){
      var m={};try{m=JSON.parse(sec.getAttribute('data-obl-mod'))||{}}catch(_){}
      if(String(m.tag||'').toLowerCase()!=='residency')return;
      var wrap=ROOT.querySelector('.obn-after');
      if(!wrap){wrap=document.createElement('div');wrap.className='obl-discover obn-after';browser.parentNode.insertBefore(wrap,browser.nextSibling)}
      wrap.appendChild(sec);
    });
  }
  /* Oct 7 2026: one quick-filter row above the list. The separate When and Where rows are hidden (CSS);
     the chip row keeps Today, This Weekend, Live Music, Free and OB Picks, and gains a Next Weekend chip.
     Neighborhoods, categories and custom dates live in the sidebar (Refine on phones). */
  function nextAnchor(){return ROOT.querySelector('a[data-obl-when="nextweekend"]')}
  function addNextChip(){
    var chips=document.getElementById('obgChips');if(!chips||chips.querySelector('[data-obn-next]'))return;
    var wk=chips.querySelector('[data-chip="weekend"]');if(!wk||!nextAnchor())return;
    var b=wk.cloneNode(true);b.removeAttribute('data-chip');b.setAttribute('data-obn-next','');b.setAttribute('aria-pressed','false');
    var sp=b.querySelector('span');if(sp)sp.textContent='Next Weekend';
    wk.parentNode.insertBefore(b,wk.nextSibling);
  }
  function bindNextChip(){
    document.addEventListener('click',function(e){
      var t=e.target;if(!t.closest)return;
      var b=t.closest('#obgChips [data-obn-next]');
      if(b){
        e.preventDefault();
        var on=b.getAttribute('aria-pressed')==='true';
        if(on){var r=ROOT.querySelector('input[name="obg-when"][value="all"]');if(r){r.checked=true;fire(r)}b.setAttribute('aria-pressed','false');lastNext=null;confirmChange();return}
        var a=nextAnchor();
        if(a&&nextWeekend(a)){
          Array.prototype.forEach.call(document.querySelectorAll('#obgChips [data-chip="today"],#obgChips [data-chip="weekend"]'),function(x){x.setAttribute('aria-pressed','false')});
          b.setAttribute('aria-pressed','true');confirmChange();
        }else if(a){location.href=a.href}
        return;
      }
      if(t.closest('#obgChips [data-chip="today"],#obgChips [data-chip="weekend"]')){
        var n=document.querySelector('#obgChips [data-obn-next]');if(n)n.setAttribute('aria-pressed','false');
      }
    },true);
  }
  /* Oct 7 2026: Las Vegas is one place, so the sidebar shows one "All of Las Vegas" option with the
     neighborhoods always open under it. Anything that would switch the area to "all" (the old second
     option, the empty-state "See all" button, removing the area pill) just clears the neighborhood instead. */
  function lvRadio(){return ROOT.querySelector('input[name="obg-region"][value="'+PLACE.name+'"]')}
  function lvBackToAll(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('input[name="obg-hood"]:checked'),function(i){i.checked=false;fire(i)});
    var r=lvRadio();if(r&&!r.checked){r.checked=true;fire(r)}
  }
  function lvLabel(){
    var r=lvRadio(),l=r&&r.closest('label'),t=l&&(l.querySelector('.obg-opt-label')||l);
    if(t&&t.textContent.trim()===PLACE.name)t.textContent=PLACE.all;
  }
  function bindLv(){
    if(!DEST)return;
    ROOT.classList.add('obn-lv');
    document.addEventListener('change',function(e){
      var t=e.target;if(!t||t.name!=='obg-region'||t.value!=='all'||!t.checked)return;
      e.stopImmediatePropagation();lvBackToAll();
    },true);
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('#obg [data-rchip="all"],#obg [data-remove="region"]');if(!b)return;
      e.preventDefault();e.stopImmediatePropagation();lvBackToAll();confirmChange();
    },true);
  }

  /* Oct 7 2026: when a search comes up empty, point people to the happy hours + weekly page for the same day,
     since weekly regulars (happy hours, trivia, karaoke) are kept off the main event list. */
  var DOW=['sun','mon','tue','wed','thu','fri','sat'];
  function pacificDow(key){
    var d=key?new Date(key+'T12:00:00Z'):new Date();
    var w=new Intl.DateTimeFormat('en-US',{timeZone:key?'UTC':(window.OB_GUIDE_TZ||'America/Los_Angeles'),weekday:'short'}).format(d).slice(0,3).toLowerCase();
    return DOW.indexOf(w)>-1?w:'';
  }
  /* link to the weekly page, opened on the same day when the list is filtered to one day */
  function wkLink(){
    var st=null;try{st=window.OB_GUIDE_V3.state()}catch(_){}
    var day='',label='';
    if(st&&(st.when==='today'||st.when==='tonight')){day=pacificDow();label=st.when}
    else if(st&&st.when==='custom'&&st.from&&st.from===st.to){day=pacificDow(st.from);label='that day'}
    return {href:url(PLACE.weekly)+(day?'?day='+day:''),label:label,hood:st&&st.hoods&&st.hoods.length===1?st.hoods[0]:''};
  }
  function weeklyNudge(){
    var list=document.getElementById('obgList');if(!list||WEEKLY)return;
    function add(){
      var em=list.querySelector('.obg-empty');if(!em||em.querySelector('.obn-wk-nudge'))return;
      var w=wkLink(),p=document.createElement('p');p.className='obn-wk-nudge';
      p.innerHTML='Happy hours, trivia and weekly regulars'+(w.hood?' in '+esc(w.hood):'')+' live on their own page. <a href="'+w.href+'">See happy hours + weekly'+(w.label?' for '+esc(w.label):'')+' &rarr;</a>';
      em.appendChild(p);
    }
    if(window.MutationObserver)new MutationObserver(add).observe(list,{childList:true,subtree:true});
    add();
  }
  /* Oct 7 2026: once someone reaches the true end of the list (no more "Show more"), a small card
     points them to the happy hours + weekly page. Hidden in calendar and map view and on empty results. */
  function endCard(){
    var list=document.getElementById('obgList'),more=document.getElementById('obgMoreWrap');if(!list||!more||WEEKLY)return;
    if(ROOT.querySelector('.obn-end'))return;
    var card=document.createElement('div');card.className='obn-end';card.hidden=true;
    more.parentNode.insertBefore(card,more.nextSibling);
    var t;
    function upd(){
      var moreOn=!more.hidden&&getComputedStyle(more).display!=='none';
      var atEnd=!!list.querySelector('.obg-row')&&!list.querySelector('.obg-empty')&&!moreOn&&!list.hidden&&list.offsetParent!==null;
      card.hidden=!atEnd;if(!atEnd)return;
      var w=wkLink();
      card.innerHTML='<p><strong>That\'s everything for these filters.</strong>Happy hours, trivia and weekly regulars'+(w.hood?' in '+esc(w.hood):'')+' live on their own page.</p><a class="obn-end-btn" href="'+w.href+'">See happy hours + weekly'+(w.label?' for '+esc(w.label):'')+' &rarr;</a>';
    }
    function soon(){clearTimeout(t);t=setTimeout(upd,60)}
    if(window.MutationObserver){
      new MutationObserver(soon).observe(list,{childList:true});
      new MutationObserver(soon).observe(more,{attributes:true,attributeFilter:['hidden','style']});
      new MutationObserver(soon).observe(ROOT,{attributes:true,attributeFilter:['data-mode']});
    }
    upd();
  }

  function init(){buildBar();moveResidencies();flagWhen();addNextChip();watchSelect();lvLabel();weeklyNudge();endCard()}
  bindTaps();bindNextChip();bindLv();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  /* the guide fills the picker after it boots; catch that too */
  window.addEventListener('load',function(){groupSelect();flagWhen();addNextChip();lvLabel()});
})();
